// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1tyEg","header":"PatientQuestionnaire_header__2mYJ4","info":"PatientQuestionnaire_info__23P-J"};